import { TYPE_BOOLEAN } from './input-types';

export const id = 'rate';
export const apiKey = 'HasRate';
export const type = TYPE_BOOLEAN;

export const rate = {
  id,
  apiKey,
  type,
};
